import { httpManager as http } from '@/common/js/HttpManager';
import { config } from 'CONFIG';
import {plan as planStatus, subscription as subStatus} from '@/config/status';
import router from '@/router';
import { orderedProductInfo, getProducts as getProductsOld } from './plan';
import { requestToApp, registerHandler } from '@/api/app';
import moment from 'moment';
import store from '@/store';
import { isMobile } from '@/common/js/utils';

export const getPaymentsMethods = () => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/payment-methods/?client_id=${encodeURIComponent( config.clientId )}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });
    
};

export const getPlan = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/plans/${id}/?client_id=${encodeURIComponent( config.clientId )}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

export const getOrderDetailById = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/orders/${id}` ).then( res => {

            resolve( res );

        }).catch( err => {

            console.error( err );
            reject( err );

        });

    });

};

export const checkBeta = async () => {

    let res = await http.get( `/shop/plans/?client_id=${encodeURIComponent( config.clientId )}` );
    let showBeta = true;
    let products = res.data;
    for ( let product of products ) {

        if ( product.status === planStatus.ENABLED ) {

            showBeta = false;
            break;

        }

    }
    store.commit( 'SHOW_BETA', showBeta );

};

export const getProducts = async ({

    classify = true,
    activityPlanId = 0

} = {}) => {

    let res = await http.get( `/shop/plans/?client_id=${encodeURIComponent( config.clientId )}` );
    let data = res.data;
    if ( !classify ) {

        return data;

    }
    let showBeta = true;
    for ( let product of data ) {

        if ( product.status === planStatus.ENABLED ) {

            showBeta = false;
            data = data.filter(( product ) => {

                return product.status === planStatus.ENABLED;
                
            });
            break;
            
        }
        
    }
    store.commit( 'SHOW_BETA', showBeta );
    if ( showBeta ) {

        for ( let product of data ) {

            if ( product.title === config.beta_plan_title ) {

                let betaPlanOldres = await getProductsOld();
                let betaPlanOld = betaPlanOldres[ 0 ];
                product.metadata[ 'virtual_product.effect_ttl' ] = betaPlanOld.metadata[ 'virtual_product.effect_ttl' ];
                product.stockQuantity = betaPlanOld.stockQuantity;

            } else {

                product.metadata[ 'plan.recommended' ] = 0;

            }
            
        }

    }
    // 过滤当前用户生效中的活动套餐
    if ( activityPlanId ) {

        data = data.filter(( product ) => {
        
            return product.id !== activityPlanId;
            
        });

    }
    
    let products = [];
    let serialNames = [];
    for ( let product of data ) {

        let { serialName } = product;
        if ( serialNames.includes( serialName )) {

            let index = serialNames.indexOf( serialName );
            products[ index ].products.push( product );

        } else {

            products.push({
                        
                serialName,
                'products': [ product ]

            });
            serialNames.push( serialName );

        }
        
    }
    return products;

};

/**
 * 用户切换、购买套餐统一处理
 * @param {*} plan 套餐id
 * @param {*} quantity 套餐数量
 * @param {*} paymentMethod 支付方式id
 */
export const subscriptions = async (

    planId,
    quantity,
    paymentMethod,
    prevSub,
    needPay,
    mode,
    payerAccount = '',
    payerFrom = 'paypal'

) => {

    if ( !prevSub ) {

        try {

            prevSub = await orderedProductInfo();

        } catch ( err ) {

            console.error( err );

        }

    }
    /**
     * 如果当前有next plan（一定是pending状态的）而且是续费时
     * 
     * 则先切换回当前套餐
     */
    // if ( prevSub !== null && prevSub.nextPlan && prevSub.plan.id === planId ) {

    //     prevSub = await createSubscription( prevSub.plan.id );

    // }
    /**
     * 创建订阅
     */
    if ( needPay === undefined ) {

        try {

            let preview = await previewSubscriptions( planId, quantity );
            needPay = preview.payment;

        } catch ( err ) {

            console.error( err );

        }

    }

    let sub = '';

    if ( !needPay && payerAccount ) {

        sub = await createSubscription( planId, payerAccount, payerFrom );

    } else {

        sub = await createSubscription( planId );

    }

    let { plan } = sub;
    let redirectUrl;
    let query = {};
    // 将订阅之前的plan id通过redirectUrl传递给complete页面，用以统计
    // 仅仅web端需要支付的时候需要这么做
    // webview或者不需要支付时，checkout -> payment-complete/complete
    // 此时应用没有被销毁或者刷新，reolinkGa内部的状态还保留着，直接使用就好
    let prevPlan = prevSub ? prevSub.plan.id : 0;

    /**
     * 如果需要付费
     * 
     * 支付完成后一律跳转到order complete页面
     */
    if ( needPay ) {

        redirectUrl = config.platform === 'web' ? `${window.location.origin}/checkout/payment-complete/?r-cloud-id={order-id}&r-cloud-method={method-uuid}&r-cloud-result={result}&r-cloud-paymentMethod=${paymentMethod}&r-cloud-platform=${config.platform}&r-cloud-mode=${mode}&r-cloud-prevPlan=${prevPlan}` : config.app_url;

        let paymentRes;

        for ( let i = 0; i < 10; i++ ) {

            try {

                paymentRes = await http.post( `/shop/orders/`, {

                    type: 'subscription',
                    subject: sub.id,
                    autoBilling: false,
                    quantity: quantity
        
                });

            } catch ( err ) {

                let code = err.response.data.error.code;
                if ( code === 53263 ) {

                    // eslint-disable-next-line promise/param-names
                    await new Promise(( r ) => setTimeout( r, 5000 ));
                    continue;
                
                } else {

                    throw err;

                }

            }

            break;
        
        }

        if ( !paymentRes ) {

            throw new Error( 'Create Order Failed!' );
        
        }
        let { id } = paymentRes.data;
        let payPlatform;
        if ( config.platform === 'web' ) {

            if ( isMobile()) {

                payPlatform = 'mobile_web';

            } else {

                payPlatform = 'pc_web';

            }

        } else {

            payPlatform = 'mobile_app';

        }
        let paymentSessionRes = await http.post( `/shop/orders/${id}/payments/`, {

            platform: payPlatform,
            paymentMethod: paymentMethod,
            returnUrl: redirectUrl

        });

        let { url } = paymentSessionRes.data;

        if ( config.platform === 'web' ) {
            
            window.location.href = url;

        } else {

            let data = {

                url: url

            };
            registerHandler( 'returnedToWebview', () => {

                store.commit( 'RETURN_TO_WEBVIEW_FIRST_TIME', true );

            });
            requestToApp( 'payApp', data );
            router.push({

                path: '/checkout/payment-complete/',
                query: {

                    'r-cloud-id': id,
                    platform: config.platform

                }

            });

        }
        return true;

    } else {

        redirectUrl = `/user/complete/`;
        query.mode = mode;

        if ( prevSub && prevSub.status === subStatus.ACTIVE && Number( prevSub.plan.cycle.standard.salePrice ) > 0 && Number( plan.cycle.standard.salePrice ) === 0 ) {

            query.refund = true;
            
        }

    }
    router.push({

        path: redirectUrl,
        query

    });
    return true;

};

export const previewSubscriptions = async ( plan, quantity ) => {

    return new Promise(( resolve, reject ) => {

        http.post( '/shop/subscriptions/preview/', {

            plan,
            quantity

        }, {

            frequency: 'previewSubscription'

        }).then(({ data }) => {

            resolve( data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const createSubscription = ( plan, payerAccount, payerFrom ) => {

    return new Promise(( resolve, reject ) => {

        let data = JSON.parse( JSON.stringify({
            plan,
            payerAccount,
            payerFrom
        }));

        http.post( `/shop/subscriptions/`, data ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const approval = ( paymentMethodId, querystring ) => {

    return new Promise(( resolve, reject ) => {

        http.post(

            `/shop/payment-methods/${paymentMethodId}/commitment/`,
            querystring

        ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const cancelPayment = id => {

    return new Promise(( resolve, reject ) => {

        http.delete( `/shop/orders/${id}/` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getPaymentHistory = ( year, id ) => {

    let start;
    let end;
    if ( year !== 'all' ) {

        start = moment( year, 'YYYY' ).unix() * 1000;
        end = moment( year, 'YYYY' ).add( 1, 'y' ).unix() * 1000;

    }
    return new Promise(( resolve, reject ) => {

        http.get( `/shop/orders/?page_type=waterfall&limit=20${id ? `&max_id=${id}` : ''}${year !== 'all' ? `&date_start=${start}&date_end=${end}` : ''}` ).then( res => {

            resolve( res.data.items );

        }).catch( err => {

            reject( err );

        });

    });

};

export const queryPaymentResult = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/orders/${id}/result` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};



// WEBPACK FOOTER //
// ./src/api/cart.js